<template>
  <el-select class="picker" size="small" v-model="cake" placeholder="Chocolate Cake Slice?" @change="cakeChange">
    <el-option
      v-for="cyn in cakeYesNo"
      :key="cyn.value"
      :label="cyn.label"
      :value="cyn.value">
    </el-option>
  </el-select>
</template>

<script>

export default {
  name: 'cakePicker',
  data() {
    return {
      cakeYesNo: [{
        value: "true",
        label: "Yes, Chocolcate Cake ($5.80)",
      },{
        value: "false",
        label: "No, Chocolate Cake",
      }]
    }
  },
  computed: {
    cake: {
      get() {
        return this.$store.state.userInfo.cake
      },
      set( val ) {
        this.$store.commit( 'userInfo/UPDATE_CAKE', val )
      }
    }
  },
  methods: {
    cakeChange() {
      this.$emit( 'cakeChange', this.cake )
    }
  }
}

</script>

<style scoped lang="scss">
</style>